import React from "react";
import EventCard from "./EventCard.jsx";

/**
 * EventList - Displays a grid of event cards
 * 
 * Renders a responsive grid layout of event cards or a message when no events exist.
 * 
 * @component
 * @param {Object} props
 * @param {Array} props.events - Array of event objects to display
 * @param {Function} props.handleDeleteClick - Callback for delete action (type, eventName)
 * @param {Function} props.handleRedirect - Callback for card click navigation
 * 
 * @example
 * <EventList
 *   events={filteredEvents}
 *   handleDeleteClick={handleDeleteClick}
 *   handleRedirect={handleRedirect}
 * />
 */

const EventList = ({ events, handleDeleteClick, handleRedirect }) => (
  <div className="grid grid-cols-1 mt-10 min-[500px]:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 lg:gap-8 justify-items-center justify-content-center items-center px-10 md:px-12 lg:px-24">
    {events.length > 0 ? (
      events.map((event) => (
        <EventCard
          key={event._id}
          eventData={event}
          onDelete={() => handleDeleteClick("events", event.eventName)}
          onRedirect={handleRedirect}
        />
      ))
    ) : (
      <h3>No events created yet.</h3>
    )}
  </div>
);

export default EventList;
